export * from './types';
export { cricketPlayerSchema } from './cricket-player.schema';
export { movieSchema } from './movie.schema';
export { movieSongSchema } from './movie-song.schema';

import type { EntitySchema } from './types';
import { cricketPlayerSchema } from './cricket-player.schema';
import { movieSchema } from './movie.schema';
import { movieSongSchema } from './movie-song.schema';

// Map of entity type to schema
export const ENTITY_SCHEMAS: Record<string, EntitySchema> = {
  cricket_player: cricketPlayerSchema,
  movie: movieSchema,
  movie_song: movieSongSchema,
};

// Get schema by entity type
export function getSchemaForEntityType(entityType: string): EntitySchema | undefined {
  return ENTITY_SCHEMAS[entityType];
}

// Get all available entity types
export function getAvailableEntityTypes(): string[] {
  return Object.keys(ENTITY_SCHEMAS);
}
